import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { PageLayout } from "@/components/VocationalTest/PageLayout"
import { CheckCircle2 } from "lucide-react"
import desbloqueioImg from "@/assets/desbloqueio.png"

export default function AdvancedWelcomePage() {
  return (
    <PageLayout>
      <Card className="w-full max-w-4xl p-8 md:p-12 bg-white">
        <div className="space-y-8">
          <div className="space-y-4">
            <div className="flex items-center justify-center gap-3">
              <img src={desbloqueioImg} alt="Desbloqueio" className="w-12 h-12 object-contain" />
              <h1 className="text-3xl md:text-4xl font-bold text-foreground">Parabéns!</h1>
            </div>

            <p className="text-lg text-muted-foreground leading-relaxed">
              Você acaba de desbloquear a parte mais profunda, precisa e transformadora da nossa Orientação Profissional.
              Isso mostra que você está realmente comprometido com o seu futuro — e isso já te coloca à frente da maioria das pessoas da sua idade.
            </p>

            <p className="text-lg text-foreground font-semibold">
              Aqui começa a segunda etapa da sua jornada:
            </p>

            <p className="text-lg text-muted-foreground leading-relaxed">
              um processo pensado especialmente para te ajudar a entender quem você é por dentro, como você funciona e para qual caminho profissional sua personalidade aponta com mais força.
            </p>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-foreground">
              O que você vai encontrar a partir de agora
            </h2>

            <p className="text-lg text-muted-foreground">
              Nesta versão avançada, você terá acesso a:
            </p>

            <div className="space-y-4">
              <div className="flex gap-4">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">
                    Uma nova etapa exclusiva do teste
                  </h3>
                  <p className="text-muted-foreground">
                    25 perguntas especialmente desenvolvidas para aprofundar o seu perfil emocional, cognitivo e vocacional.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">
                    Refinamento do seu tipo
                  </h3>
                  <p className="text-muted-foreground">
                    Vamos analisar não apenas o que você faz, mas por que faz, como sente, como aprende e como decide, conectando tudo ao seu tipo de personalidade.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">
                    Microperfis vocacionais
                  </h3>
                  <p className="text-muted-foreground">
                    Você terá acesso a uma leitura muito mais detalhada de como você pensa, sente e age no mundo.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">
                    Profissões específicas para o seu jeito de ser
                  </h3>
                  <p className="text-muted-foreground">
                    Baseado na combinação do seu perfil emocional + área vocacional + suas preferências reais.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">
                    Indicações de caminhos, áreas, possibilidades e ambientes de trabalho
                  </h3>
                  <p className="text-muted-foreground">
                    para você entender onde teria mais prazer, energia e potencial de crescimento.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center pt-6">
            <Button
              onClick={() => router.visit("/advanced-instructions")}
              size="lg"
              className="px-12 text-lg"
            >
              Começar Teste Avançado
            </Button>
          </div>
        </div>
      </Card>
    </PageLayout>
  )
}
